import { Button, Col, Row,DatePicker } from 'react-materialize';
import LoadingView from '../loading/loading.view';
import Modal from './modal';
import React from 'react';
import Swal from 'sweetalert2';
import { ErpConnect as qad } from '../../../services';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridColumn } from '@progress/kendo-react-grid';




// servicios

class ModalOC extends React.Component {
  state = {
      loading: false,
      patterns: [],
      date: new Date(),
      excelExport: null,
      user: JSON.parse(localStorage.getItem('user')),
      dataByBrand: {},
      strDate : (new Date()).toISOString().substring(0, 10),
      data: []
  }
  _export;

  async componentDidMount() {
  }

  handleCloseModal = () => {
    this.setState({
      loading: false,
      patterns: [],
      date: new Date(),
      excelExport: null,
      user: JSON.parse(localStorage.getItem('user')),
      dataByBrand : [],
      strDate : (new Date()).toISOString().substring(0, 10),
      data: []
    });
    this.props.onClose();
  };

  search = async () => {
    this.setState({loading:true});
    if( this.state.date )
    {
      const data = await qad.catalog.inventory.restock(  ( this.state.date.getMonth() < 9 ? '0'+(this.state.date.getMonth()+1) : (this.state.date.getMonth()+1) ) + '/' + (this.state.date.getDate() <= 9 ? '0'+this.state.date.getDate() : this.state.date.getDate()) + '/' + this.state.date.getFullYear() );
      let dataByBrand = {};
      data.forEach(function(item){ //no esta modificando el arreglo, solo lo esta recorriendo
        if ( dataByBrand[item.brandId] === undefined )
        {
          dataByBrand[item.brandId] = { ...item };
          dataByBrand[item.brandId]['products'] = {};
        }
        if( dataByBrand[item.brandId]['products'][item.productName] === undefined )
        {
          dataByBrand[item.brandId]['products'][item.productName] = { ...item };
          dataByBrand[item.brandId]['products'][item.productName]['size_color'] = [];  
        }
        dataByBrand[item.brandId]['products'][item.productName]['size_color'].push(item);
      });
      console.log(dataByBrand);
      this.setState({dataByBrand, data, loading:false});
    }
  }

  /**
 *
 * @param headers
 * @param items
 * @param fileName
 */
  exportCSVFile = (headers, items, fileName) => {
    if (headers) {
      items.unshift(headers);
    }
    const jsonObject = JSON.stringify(items);
    const csv = this.convertToCSV(jsonObject);
    const exportName = fileName + ".csv" || "export.csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
     if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, exportName);
     } else {
      const link = document.createElement("a");
      if (link.download !== undefined)
      {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  convertToCSV = (objArray) => 
  {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        line += array[i][index];
      }
      str += line + "\r\n";
    }
    return str;
  }
  

  generateOC = async () => 
  {
    this.setState({
      loading: true
    });
    const sentData = this.state.data.filter( (item) => item.quantity > 0 ).map((item) =>{
      return {
        productId : item.productId,
        quantity  : item.quantity
      };
    });
    if ( !this.state.loading && sentData.length > 0 )
    {
      const data = await qad.catalog.inventory.createStockOrder({
          vendorId : "P000001",
          po       : "1216620",
          lines    : sentData
        }
      );
      if ( data?.id )
      {
        Swal.fire({title:"Se creó la Orden de Compra: "+ data.id });
      }
      else
      {
        Swal.fire({title:"No se creó la Orden de Compra"});
      }
    }
    else
    {
      Swal.fire({title:"No hay ningun elemento para enviar"});
    }
    this.setState({
      loading: false
    });
  };

  generateCSV = async () => {
    if ( !this.state.loading )
    {
      const fileName  = 'OC_'+this.state.strDate+'.xlsx';
      const user      = JSON.parse(localStorage.getItem('user'));
      const excelData = this.state.data.filter( (item) => item.quantity > 0 ).map((item) => {
        return {
          id  : item.ean, 
          qty : item.quantity
        }}
      );
      this.setState( { excelExport: this.renderExcel(excelData, fileName) }, () => { this.export(excelData) } )
      console.log(excelData, fileName, user);
    }
    else
    {
      Swal.fire({title:"No se ha seleccionado la Marca"});
    }
  };

  modifyProduct = (item, quantity) =>
  {
    let currentData = this.state.data;
    item.quantity = parseInt(quantity);
    const currentIndex = currentData.findIndex((current) => current.productId === item.productId );
    if ( currentIndex !== -1 )
    {
      currentData[currentIndex] = item;
      this.setState({data:currentData});
    }
  }

  render() {
    this.brands = this.props.catalog.brands.map((b) => { return { label: b.name, value:b.id} });
    this.filtredRacks = this.ubications = []
 

    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.isOpen}
          onClose={this.handleCloseModal}
        >
          <div>
            <Row>
              <Col s={12} m={12} l={12} xl={12}>
                <h4 className="m3">Re-Stock</h4>
                <DatePicker
                  options={{
                    autoClose: true,
                    container: null,
                    defaultDate: this.state.date,
                    disableDayFn: null,
                    disableWeekends: false,
                    events: [],
                    firstDay: 0,
                    format: 'yyyy-mm-dd',
                    i18n: {
                      cancel: null,
                      clear: 'Clear',
                      done: null
                    },
                    onSelect: (date) => { this.setState({date}) }
                  }}
                />
                <Button onClick={ this.search }>
                  Actualizar
                </Button>
              </Col>
            </Row>
            <Row>
              {
                this.state.loading 
                ? 
                  <LoadingView /> 
                :
                  Object.values(this.state.dataByBrand).map((brand)=>{
                    return (
                        <Col key={brand.brandId} s={12}>
                          <h4>{brand.brandName}</h4>
                          <Row>
                            {
                              Object.values(brand.products).map((product)=>{
                                return (
                                    <Col s={12} key={product.productName}>
                                      <h5>{product.productName}</h5>
                                      <Row>
                                        {
                                          product.size_color.map((item)=>{
                                            return (
                                                <Col key={item.productId} >
                                                  <div>
                                                    Color: { item.colorName } - Talla: { item.sizeName }
                                                  </div>
                                                  <div key={"rgb_"+item.colorName} className="colorRGB" style={{background: item.colorHexa }}>&nbsp;</div>
                                                  <div key={"ean_"+item.ean}>Cod. {item.ean}</div>
                                                  <input 
                                                    key={"input_"+item.productId}
                                                    title={item.sizeName} 
                                                    value={item.quantity ? item.quantity : 0 } 
                                                    type="number"
                                                    onChange={(e) => this.modifyProduct(item, parseInt(e.target.value)) } />
                                                </Col>
                                              );
                                          })
                                        }
                                      </Row>
                                    </Col>
                                  );
                              })
                            }
                          </Row>
                        </Col>
                      );
                  })
              }
            </Row>
            <br/>
            { 
              <Row>
                <Col s={12}></Col>
                <Col className="p-bottom s8">
                  <Button disabled={this.state.loading} onClick={()=> this.generateCSV() }>Generar Archivo</Button>
                </Col>
                <Col className="p-bottom s4 l3 offset-l1">
                  <Button className="delete" disabled={this.state.loading} onClick={()=> this.generateOC() }>Generar OC</Button>
                </Col>
              </Row>
            }
            <div className="hide">
              {
                this.state.excelExport
              } 
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
  
  export = (data) => {
    this._export.save(data);
  };

  renderExcel(data, fileName) {
    return (
      <ExcelExport ref={(exporter) => (this._export = exporter)} fileName={fileName}>
        <Grid
          data={data}
        >
          <GridColumn
            width="100px"
            field="id"
            title="Item"
          ></GridColumn>
          <GridColumn
            width="120px"
            field="qty"
            title="Cantidad"
          ></GridColumn>
        </Grid>
      </ExcelExport>
    );
  }
}
export { ModalOC as default };

